module.exports = __webpack_public_path__ + "static/paycheck-logo-af2a488b3de301547fb1cc010860db5b.png";